<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banner2">
					<div class="mendio2"> 
							<div class="name6">为棋牌室赋能升级</div>
							<div class="Intro6">让棋牌室增加无人自助值守能力</div>
							<el-button type="text" class="Ufree" @click="goCont"><span 
								style="color: #fff !important;margin-left: unset !important;">预约咨询</span></el-button>
							<div class="Comuni">咨询电话：159 8989 7729</div> 
					</div>
				</div> 
				<div class="pBox"> 
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">无人自助值守</div>
							<div class="pLcont">
								<li>智能控制，门、灯、空调等，节省人力电力</li>
								<li>自助预约，可选包间、桌台、时间、套餐</li>
								<li>自助开门，自动计时，无需人员值守</li>
								<li>智能提醒，开始、即将结束、过期、待清洁，让用户能及时处理</li>
							</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/temb6.png" class="pImg" />
						</div> 
					</div>
				</div>
				<div class="pBox2"> 
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">美团抖音引流</div>
							<div class="pLcont">
								<li>优惠券发布、管理</li>
								<li>美团、大众点评、抖音验券核销</li>
								<li>通过微信小程序，让客户转换为会员，提高顾客粘性，提升二次消费率</li>
							</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/temb9.png" class="pImg" />
						</div>
					</div>
				</div>
				<div class="pBox"> 
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">更多功能</div>
							<div class="pLcont">
								<li>店长功能：门店管理、会员管理、订单管理、运营功能</li>
								<li>保洁功能：保洁设置、保洁提醒、保洁任务</li>
							</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/pic2.png" class="pImg" />
						</div>
					</div>
				</div> 
				<div class="others">
					<img class="othersPic" src="../assets/images/def/hand.jpg" /> 
				</div>
				<msg-foot></msg-foot>
			</div>
			<right-cont :dialogVisible="dvSaas"></right-cont>
			<!-- <right-cont :dialogVisible="dvQuan"></right-cont>
			<right-cont :dialogVisible="dvStore"></right-cont> -->
		</div>
		<el-dialog title="" :visible.sync="dvSaas" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/saas_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvQuan" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/qr_tool.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvStore" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/store_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import msgFoot from '../components/msgFoot.vue'
	import rightCont from '../components/rightCont.vue'
	import axios from 'axios'
	export default {
		components: {
			msgFoot,
			rightCont
		},
		data() {
			return {
				textCss1: 'guideActive',
				textCss2: 'guideText',
				textCss3: 'guideText',
				textCss4: 'guideText',
				dialogVisible: false,
				dvSaas: false,
				dvQuan: false,
				dvStore: false, 
				activeIndex: '1'
			}
		},
		methods: {
			goCont()
			{  
				console.log('xxxxzz', this.$children[2]) 
				rightCont.openMe(this.$children[2]);
			},
			changeCont(e) {
				this.textCss1 = 'guideText'
				this.textCss2 = 'guideText'
				this.textCss3 = 'guideText'
				this.textCss4 = 'guideText'
				if (e == 1) {
					this.textCss1 = 'guideActive'
				} else if (e == 2) {
					this.textCss2 = 'guideActive'
				} else if (e == 3) {
					this.textCss3 = 'guideActive'
				} else if (e == 4) {
					this.textCss4 = 'guideActive'
				}
			},
			handleClose(done) {
				done();
			}
		},
		mounted() {
			window.scroll(0, 0);

		}
	}
</script>
  
